import React from 'react';

import { FiX } from 'react-icons/fi';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useCookieConsent } from '../../Hooks/useCookieConsent';

import CookieSettings from './CookieSettings';

import './style.css';

const CookieBanner = () => {
  const { t } = useTranslation();
  const {
    showBanner,
    showSettings,
    acceptAll,
    rejectAll,
    openSettings,
    closeSettings,
    consent,
    updateConsent,
    saveSettings,
  } = useCookieConsent();

  return (
    <>
      {/* Floating Cookie Button - Always visible */}
      {!showBanner && (
        <button
          className='CookieBanner__float-button'
          onClick={openSettings}
          aria-label={t('cookieBanner.manageCookies')}
          title={t('cookieBanner.manageCookies')}
        >
          🍪
        </button>
      )}

      {/* Cookie Banner - Only when first visit or no consent */}
      {showBanner && (
        <div className='CookieBanner' data-aos='fade-up' data-aos-duration='500'>
          <button
            className='CookieBanner__close'
            onClick={rejectAll}
            aria-label={t('cookieBanner.rejectAll')}
          >
            <FiX />
          </button>
          <div className='CookieBanner__container'>
            <div className='CookieBanner__content'>
              <div className='CookieBanner__icon'>🍪</div>
              <div className='CookieBanner__text'>
                <h3 className='CookieBanner__title'>
                  {t('cookieBanner.title')}
                </h3>
                <p className='CookieBanner__message'>
                  {t('cookieBanner.message')}{' '}
                  <Link
                    to='/polityka-prywatnosci'
                    className='CookieBanner__link'
                  >
                    {t('cookieBanner.privacyPolicy')}
                  </Link>
                </p>
              </div>
            </div>

            <div className='CookieBanner__actions'>
              <button
                className='CookieBanner__button CookieBanner__button--settings'
                onClick={openSettings}
                aria-label={t('cookieBanner.settings')}
              >
                {t('cookieBanner.settings')}
              </button>
              <button
                className='CookieBanner__button CookieBanner__button--reject'
                onClick={rejectAll}
                aria-label={t('cookieBanner.rejectAll')}
              >
                {t('cookieBanner.rejectAll')}
              </button>
              <button
                className='CookieBanner__button CookieBanner__button--accept'
                onClick={acceptAll}
                aria-label={t('cookieBanner.acceptAll')}
              >
                {t('cookieBanner.acceptAll')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Cookie Settings Modal */}
      {showSettings && (
        <CookieSettings
          consent={consent}
          updateConsent={updateConsent}
          saveSettings={saveSettings}
          acceptAll={acceptAll}
          closeSettings={closeSettings}
        />
      )}
    </>
  );
};

export default CookieBanner;
